import { IStorageService } from "@core/storage";
import { PageCacheKey } from "@modules/basic/page";
import { AnonymousPageObjectTreeService } from "@modules/basic/page/anonymous/anonymous-page-object-tree.service"; 

export class RegistObjectTreeService extends AnonymousPageObjectTreeService{

    public static readonly $inject: Array<string> = ["storageService"];

    constructor(
        public storageService: IStorageService<PageCacheKey>
    ) {
        super();

    }
}